import api from './api';

export interface Tool {
  title: string;
  name: string;
  description: string;
  icon: string;
}

export interface Agent {
  id: string;
  name: string;
  description: string;
  icon: string;
  endpoint_path: string;
  tools: Tool[];
}

/**
 * Fetch all available agents from the Echo backend
 * @returns Promise with array of agents
 */
export const fetchAgents = async (): Promise<Agent[]> => {
  try {
    const response = await api.get<Agent[]>('/api/v1/chat/agents');

    return response.data;
  } catch (error) {
    console.error('Failed to fetch agents:', error);
    throw error;
  }
};
